import React from 'react';
import { CircleCheck } from '@saleshandy/icons';

const GreenCircleCheck = () => (
  <CircleCheck className="green-txt-16" />
);

export default GreenCircleCheck;
